import React from 'react';
import styled from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';
import Layout from 'gatsby-theme-core/src/layout/layout';
import Container from 'gatsby-theme-core/src/components/container';
import Content from 'gatsby-theme-core/src/components/content';
import AfterContent from 'gatsby-theme-pagebuilder/src/components/after-content';
import dateFormat from './date-format';

const regexRemoveHtml = /(<([^>]+)>)/ig;

const Post = ({
  title,
  date,
  author,
  content,
  featuredImage,
  excerpt,
  path,
  lang = 'nl',
  blogPage,
  children,
}) => {
  const head = {
    headPageTitle: title,
    headTitle: `${title}, ${dateFormat(date)}, ${author.node.name}`,
    headSlug: path,
    headMetaDescription: excerpt.replace(regexRemoveHtml, '').replace('[&hellip;]', '...'),
    headImage: featuredImage?.node ? {
      src: featuredImage.node.mediaItemUrl,
      width: featuredImage.node.mediaDetails?.width,
      height: featuredImage.node.mediaDetails?.height,
    } : null,
  };

  return (
    <Layout {...head}>
      <PostWrapper lang={lang}>
        {featuredImage?.node && (
          <Container css="margin-bottom: 3rem">
            <Image
              image={featuredImage.node}
            />
          </Container>
        )}
        <Container small>
          <Title dangerouslySetInnerHTML={{ __html: title }} />
          <Info>{dateFormat(date)}, {author.node.name}</Info>
          <Content $content={content} />
        </Container>
      </PostWrapper>
      {children}
      <AfterContent
        afterContentSections={blogPage.afterContentSections}
      />
    </Layout>
  );
};

export default Post;

const PostWrapper = styled.article`
  background-color: ${(props) => props.theme.gray1};
  padding: 60px 0;
`;

const Title = styled.h1`
  margin: 0;
  padding-bottom: 40px;
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-size: 2rem;
  line-height: 2.5rem;
  text-transform: uppercase;
`;

const Info = styled.span`
  display: block;
  text-transform: uppercase;
  font-size: 0.8889rem;
  color: ${(props) => props.theme.secondaryColor};
`;
